<template>
  <div class="page">
    <div class="ctrl">
      <a-button type="primary" @click="show_create = true">发起邀请</a-button>
    </div>
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="headimg" slot-scope="text, record">
        <img height="20px" :src="record.headimgurl" alt="">
      </template>
      <template slot="action" slot-scope="text, record">
        
      </template>
    </a-table>

    <CreateModal v-if="show_create" :activity_id="activity_id" @callback="created" />
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
import CreateModal from "./create";

const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "头像",
    scopedSlots: {
      customRender: "headimg",
    },
  },
  {
    title: "昵称",
    dataIndex: "nickname",
  },
  {
    title: "姓名",
    dataIndex: "name",
  },
  {
    title: "电话",
    dataIndex: "tel",
  },
  {
    title: "城市",
    dataIndex: "city",
  },
  {
    title: "操作",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export default {
  components: { CreateModal },
  data() {
    return {
      columns,
      activity_id: null,
      list: [],
      show_create: false
    };
  },
  created() {
    this.activity_id = this.$route.query.id;
    this.getList();
  },
  methods: {
    changePage(e) {
      this.page.now_page = e;
      this.getList();
    },

    async getList() {
      if (!this.activity_id) return;
      const r = await this.$axios.get("/activity/yaoqing/getList", {
        params: {
          activity_id: this.activity_id,
        },
      });

      if (r.status != 1) return;
      this.list = r.list;
    },

    async updateStatus(id, status) {
      const r = await this.$axios.post("/activity/section/updateStatus", {
        id,
        status,
      });

      if (r.status == 1) this.getList();
    },

    created(e) {
      console.log(e, 22222);
      this.show_create = false;
      if (e) this.getList();
    },
  },
};
</script>